/**
 * Dinners that run outdoors, on a lawn, with people sat at them.
 *
 * Not a card on the board: nobody sets a dinner for you to be graded on. It is
 * something happening on the property, on its night, for its hours, and it
 * either runs to the end or it does not. The guests are rows in `guests.js`
 * with `dinner` set to one of these ids, and nothing here or in the logic
 * knows a single one of them.
 *
 *   lawn       the room it is held in (`level.js`)
 *   days       which days of the week it runs, Monday first, the same as a
 *              roster row's `days`
 *   from, to   its hours
 *   close      feet. A guest who has seen a herd, with the herd this close,
 *              gets up and goes. Seeing one across the lawn is something to
 *              tell a manager about; one at the next table is the end of the
 *              evening
 *   breaksUp   the share of the table still sat below which the dinner is
 *              over and the rest go too. Half: a dinner with half its covers
 *              gone is not a dinner, it is some people outside
 *   exit       the way out, in feet: off the lawn through the gate and up
 *              the lane toward the drive, where the cars are
 *   tables     the props it is laid on
 *   serves     what is laid on each, how many, and the table's height in
 *              feet: a dinner has food on the tables, and food draws what
 *              food draws. Cleared when the dinner's hours are over
 *   award      what ending it early is worth to whoever asked for it, when
 *              somebody asked (`chapters.js`, `posts`). Standing, through the
 *              rivalry matrix like any other award
 */
export const DINNERS = [
  {
    id: 'breeze-dinner',
    title: 'Dinner on the Breeze Lawn',
    lawn: 'lawn',
    days: [4],
    from: '19:00',
    to: '22:00',
    close: 20,
    breaksUp: 0.5,
    exit: [[160, 110], [128, 114], [100, 114]],
    tables: ['lawn-table-a', 'lawn-table-b'],
    serves: { kind: 'breadroll', each: 4, height: 2.5 },
    award: { kitchen: 14 },
  },
];

export const DINNERS_BY_ID = Object.freeze(Object.fromEntries(DINNERS.map((row) => [row.id, row])));

export default DINNERS;
